import { ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import HNSColors from "../../../ui library/HNSColors";
import EntityChip from "../../dynamic-views/view-management/components/fields/read-only/Chip";

export default function EntityAssociationsListItem({ data }) {
  const classes = "self-center px-0 py-2 text-center text-sm";
  const entityTypeLabel = (Array.isArray(data.entityTypes) ? data.entityTypes : [])
    .filter(Boolean)
    .join(", ");

  return (
    <ListItem className="border-b border-gray-200 px-0 hover:bg-gray-50">
      <div className="flex w-full items-center">
        <div className="w-[28%] self-center px-0 py-2 text-left text-sm">
          <Link to={`/entity/${data.id}`}>
            <Typography
              className="break-words whitespace-normal text-sm"
              sx={{ color: HNSColors.primary[500], fontWeight: 500 }}
            >
              {data.name}
            </Typography>
          </Link>
        </div>
        <div className={`${classes} w-[18%]`}>{data.entityId}</div>
        <div className={`${classes} flex w-[24%] justify-center`}>
          {entityTypeLabel ? <EntityChip label={entityTypeLabel} /> : null}
        </div>
        <div className={`${classes} w-[18%]`}>{data.einNumber}</div>
        <div className={`${classes} w-[12%]`}>{data.locationCount}</div>
      </div>
    </ListItem>
  );
}
